export default function AND() {
  return <div>Excel_AND</div>;
}
